import React, {Component} from 'react';
import './index.scss';
import {AddIcon} from 'components/Icon';

interface NewResourceButtonProps {
  className: string;
  label: string;
  note: string;
  onClick: ()=>void;
}

export default class NewResourceButton extends Component<NewResourceButtonProps> {
  render() {
    return <button className={ `new-resource-button ${this.props.className}` } onClick={this.props.onClick}>
      <AddIcon />
      <span className="label">{this.props.label}</span>
      <span className="note">{this.props.note}</span>
    </button>;
  }
}